
import React, {useState, useEffect, useMemo} from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
  // ... existing code ...
const Pagination = ({pagination, dataToUse, totalCount, pageSize, currentPage, onPageChange, onLoadMore, isLoading}) => {
  const totalPages = useMemo(() => {
    if (!pagination) return 1;
    return Math.ceil(totalCount / pageSize);
  }, [totalCount, pageSize, pagination]);

  var maxCurrentPage = useMemo(() => {
    return Math.ceil(dataToUse.length / pageSize);
  }, [dataToUse, pageSize]);

  const handlePageChange = (page) => {
    onPageChange(page);
    if (page > maxCurrentPage) {
      onLoadMore();
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  return (
    <div className='generic-table-pagination'>
      <div className='pagination-info'>
        {isLoading ? 
        <Skeleton height={20} width={100} /> : (
        totalCount > 0 ? (
          <span>
            מציג {(currentPage - 1) * pageSize + 1}-{Math.min(currentPage * pageSize, totalCount)} מתוך {totalCount} תוצאות
          </span>
        ) : (
          <span>
            מציג {(currentPage - 1) * pageSize + 1}-{Math.min(currentPage * pageSize, totalCount)} מתוך {totalCount} תוצאות
          </span>
        )
        )}
      </div>
       
       {isLoading ? 
       <Skeleton height={20} width={100} /> : (
        <div className='pagination-controls'>
          <nav aria-label='Table pagination'>
            <ul className='pagination pagination-sm mb-0'>
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <a className='page-button-link' onClick={handlePrevious} disabled={currentPage === 1}>
                  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M5.26 3.544a.874.874 0 0 1 .067-1.304 1.063 1.063 0 0 1 1.323-.019l.09.081 5 5.077a.869.869 0 0 1 .08 1.15l-.08.092-5 5.077a1.06 1.06 0 0 1-1.413.062.873.873 0 0 1-.146-1.213l.08-.091 4.388-4.455L5.26 3.544z'
                      fill={currentPage === 1 ? '#BDBCBE' : '#000'}
                    />
                  </svg>
                </a>
              </li>

              {Array.from({length: Math.min(5, totalPages)}, (_, i) => {
                let pageNum;
                if (totalPages <= 5) {
                  pageNum = i + 1;
                } else if (currentPage <= 3) {
                  pageNum = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNum = totalPages - 4 + i;
                } else {
                  pageNum = currentPage - 2 + i;
                }

                return (
                  <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                    <a className='page-button-link' onClick={() => handlePageChange(pageNum)}>
                      {pageNum}
                    </a>
                  </li>
                );
              })}

              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <a className='page-button-link' onClick={handleNext} disabled={currentPage === totalPages}>
                  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M10.74 12.456a.874.874 0 0 1-.067 1.304 1.063 1.063 0 0 1-1.323.019l-.09-.081-5-5.077a.87.87 0 0 1-.08-1.15l.08-.092 5-5.077a1.06 1.06 0 0 1 1.413-.062.873.873 0 0 1 .146 1.213l-.08.091-4.388 4.455 4.389 4.457z'
                      fill={currentPage === totalPages ? '#BDBCBE' : '#000'}
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        )}
    </div>
  );
};

export default Pagination;
